import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    q: "Why is Link prospecting important?",
    a: "Because finding the right websites for backlinks helps your site rank higher on Google. The better your link sources, the better your authority and SEO results.",
  },
  {
    q: "What makes a good link prospect?",
    a: "A relevant website with high authority, low spam score, and active editorial or partnership opportunities - like guest posts or resource links.",
  },
  {
    q: "How does Backlink Banana help?",
    a: "It automates backlink research by surfacing only relevant websites with built-in Moz metrics and LinkedIn contacts - saving hours every week.",
  },
  {
    q: "Do I get LinkedIn contacts too?",
    a: "Yes! Every discovered website comes with verified LinkedIn profiles of editors, SEO leads, outreach managers, and founders. These Linkedin Profiles are free of cost. We charge for for the blog results.",
  },
  {
    q: "How do credits work?",
    a: "Each credit equals one website result. You get 20 free credits upon signup, and can buy more anytime - no subscriptions or renewals required. We charge for websites, Linkedin profiles are complimentry.",
  },
  {
    q: "Can I export results?",
    a: "Absolutely. You can download results in CSV format - including URL, title, DA, PA, spam score, and contact profiles.",
  },
  {
    q: "Do credits or searches expire?",
    a: "Nope. Unused credits stay in your account indefinitely until you decide to use them.",
  },
  {
    q: "Is there a refund policy?",
    a: "All purchases are final, but credits never expire. You can always use them later for new searches or prospecting campaigns.",
  },
  {
    q: "What payment methods do you accept?",
    a: "We accept all major debit and credit cards via Razorpay - no hidden fees or auto-renewals.",
  },
];

export default function FaqSection() {
  const [openIndexes, setOpenIndexes] = useState<number[]>([]);

  const toggle = (i: number) => {
    setOpenIndexes((prev) =>
      prev.includes(i) ? prev.filter((x) => x !== i) : [...prev, i]
    );
  };

  return (
    <section className="relative py-24 bg-white overflow-hidden">
      <div className="max-w-5xl mx-auto px-6">
                <h2 className="text-4xl sm:text-5xl font-extrabold text-blue-900 text-center mb-8">
          Frequently{" "}
          <span className="bg-gradient-to-r from-blue-600 to-purple-500 bg-clip-text text-transparent">
            (and Infrequently)
          </span>{" "}
          Asked Questions
        </h2>

        <p className="text-lg text-gray-700 text-center max-w-2xl mx-auto mb-16">
          We’ve gathered the most common (and some uncommon) questions about
          Backlink Banana - so you can skip the guesswork and dive right in.
        </p>

        <div className="space-y-5">
          {faqs.map((item, i) => {
            const open = openIndexes.includes(i);
            return (
              <div
                key={i}
                className="border border-gray-200 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 bg-gray-50"
              >
                <button
                  onClick={() => toggle(i)}
                  className="w-full flex justify-between items-center px-6 py-5 text-left"
                >
                  <span className="text-lg sm:text-xl font-medium text-gray-900">
                    {item.q}
                  </span>
                  <ChevronDown
                    className={`w-6 h-6 transform transition-transform duration-300 ${
                      open ? "rotate-180 text-blue-600" : "text-gray-500"
                    }`}
                  />
                </button>

                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    open ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="px-6 pb-6 text-gray-700 text-md leading-relaxed">
                    {item.a}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
